import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import Prof from "../Images/Prof.jpg";
import Center from "../Images/center.jpg";
import Communication from "../Images/communication_intro.jpg";
import Research from "../Images/research.jpg";
import Publication from "../Images/publication.jpg";

class Intro extends Component {
  state = {};
  render() {
    return (
      <div className="container navbar-margin">
        <div className=" text-center">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Prof}
                alt="First slide"
                width="80"
                height="500"
              />
              <Carousel.Caption>
                <div className="home-slides">
                  <Link to="/profile">
                    <h3>Professor Grace Yawo Gadagbui</h3>
                    <p>She has wide experience in Language and.....</p>
                  </Link>
                </div>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Center}
                alt="First slide"
                width="70"
                height="500"
              />
              <Carousel.Caption>
                <div className="home-slides">
                  <Link to="/overview">
                    <h3>Facilities at the centre</h3>
                    <p>
                      This is a not-for-profit organization established in the
                      USA.....
                    </p>
                  </Link>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
        <hr />

        <div className="wrapper row">
          <div className="mission col-md-8">
            <h2 className="page-header text-center page-header mission-h1">
              <u>Mission Statement</u>
            </h2>
            <p className="text-justify">
              To train young intellectuals in the area of Educational Research
              to be capable of choosing researchable topics and writing
              proposals, conducting researches on their topics of interest for
              their MPhil, M.Ed., M.Sc., M.A., Ph.D. Thesis/Dissertations and
              projects, Long Essays, Research Reports and Journal Articles for
              publication in refereed Journals and promotion purpose. Peer
              Review Papers for Presentations, Reviewing of Research Papers,
              Seminars etc. for publications and disseminations of information
              to the public and during Viva Voce.
            </p>
            <p className="text-justify">
              The Resource Centre will cater for families and Persons with
              Communication Disorders (speech and language disorders),
              post-stroke patients with speech disorders, children with autism,
              cerebral palsy, voice disorders, fluency disorders, (Stuttering,
              Cluttering), intellectual disability, and cleft palate speech will
              be managed. Parents will be counselled on how to manage the
              emotional problems they face with their wards and acquire skills
              to train them at home. All aspects of Communication Disorders,
              delays in language and speech , reading and learning difficulties
              will have solutions. Diagnostic Assessment, Therapy, Counselling
              and Referrals will be essential aspects of the therapy session.
              Students from the Universities with related knowledge in the area
              of Communication Disorders and Dyslexia can have their practicum
              at this centre.
            </p>
          </div>

          <div className="vision col-md-4">
            <h2 className="page-header text-center vision-h1">
              <u>Vision Statement</u>
            </h2>
            <p className="text-justify ">
              To establish a Centre of excellence which will produce scholarly
              candidates in critical areas in Educational Research and be
              capable of writing research proposals, conducting research
              competently, writing scientific reports for publication in
              Refereed Journals and producing scholars who will brilliantly
              articulate the research report during Viva Voce. The resource
              centre will support families and children with skills in dealing
              with Communication Disorders and for adults with post-stroke
              patients who need to be rehabilitated in Language and Speech
              Disorders. This centre will also manage children with
              Dyslexia-Reading Difficulties.
            </p>
          </div>
        </div>
        <div className="target-groups">
          <h2>Target Groups</h2>
          <ol className="target.ol lead">
            <li>Undergraduates</li>
            <li>Masters & PhD Candidates</li>
            <li>Lecturers</li>
            <li>Families and children with Speech and Language Difficulties</li>
            <li>Children with Reading Difficulties</li>
            <li>Teachers, Resource Teachers, Coordinators etc...</li>
          </ol>
        </div>
        <div className="row">
          <h3>Services</h3>

          <div className="services col-md-4">
            <hr />
            <h4>Communication Disorders</h4>
            <img className="img-fluid" src={Communication} alt="Founders" />
            <p>
              To provide technical skills and strategies that Families and
              Persons with Communication Disorders and Dyslexia need so as to
              function according to standard as peers in an Inclusive
              Educational setting within a short period....
            </p>
            <Link to="/communication">
              <button className="contact-button">Read more</button>
            </Link>
          </div>
          <div className="services col-md-4">
            <hr />
            <h4>Educational Research</h4>
            <img className="img-fluid" src={Research} alt="Founders" />
            <p>
              The purpose of the programme is to “guide” students to write
              theses, dissertations, long essays and seminars with less
              difficulty and to present them skillfully. Identify, assess, train
              and support......
            </p>
            <Link to="/research">
              <button className="contact-button">Read more</button>
            </Link>
          </div>
          <div className="services col-md-3">
            <hr />
            <h4>Journal, Article writing and Publication</h4>
            <img className="img-fluid" src={Publication} alt="Founders" />
            <p>Purpose is to publicize the academic wrtite-ups</p>
            <Link to="/journal">
              <button className="contact-button">Read more</button>
            </Link>
          </div>
        </div>

        <div className="text-center">
          <iframe
            width="853"
            height="480"
            src="https://www.youtube.com/embed/FtkVYMArJFs"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <a href="https://forms.gle/3dxfDmfNPvopaR9t7" target="blank">
            <div className="text-center ">
              <Button variant="success" className="sign-up">
                <Spinner
                  as="span"
                  animation="grow"
                  size="md"
                  role="status"
                  aria-hidden="true"
                />
                Sign up here...
              </Button>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

export default Intro;
